const _interface = {
  "appealAda": "campaign/api/appealAda", //申诉
  "bindPhone": "campaign/api/bindPhone", //绑定
  "sendSmsCode": "mobileValidationBySMS/api/sendSlidingSmsCode", //发送验证码,{0}:需要发送的手机号码
  // "sendSmsCode": "mobileValidationBySMS/api/sendSmsCode",
  "queryAboByAda": "campaign/api/queryAboByAda", //查询ABO信息
  "validationPhoneSMS": "campaign/api/validationPhoneSMS", //校验验证码
  "analyzeToken": "sso/api/userinfo/{0}/{1}", //解释token
  "getSSOToken": "campaign/api/getSSOToken", //跳转云购
  "checkIdcard": "campaign/api/checkIdcard", //检查身份证后6位
  "validateMobileNumber": "campaign/api/validateMobileNumber", //检验手机号是否被使用
  "checkSmsCode": "mobileValidationBySMS/api/checkSmsCode",
  "getUserticket": "sso/api/userticket",
  "getJsToken": "LCAuth/LCToken", // 获取jsToken,

  'forgetAda': 'login/acc/acquire/ada',
  'checkForgetPassword': 'login/api/checkIdInfo',
  'checkPwdToken': '/login/api/checkToken',
  'setNewPwd': 'login/api/setNewPwd',


  // line绑定相关接口
  'devGetJsToken': 'auth/jstoken/hybris/hybris123',
  'adaAndPwd': 'login/api/adaAndPwd',
  'pnAndSms': 'login/api/pnAndSms',
  'pnAndPwd':'login/api/pnAndPwd',

  'bindLine': 'binder/api/bindLine',
  'getAndCheckUserId':"binder/api/getAndCheckUserId",
  'queryAdaIsLineBinding':'binder/api/queryAdaIsLineBinding',

  'getUserTicketOne': 'sso/api/line/userticket',

  // 白名单接口 
  'findWhiteList':'common/api/findWhiteList'
};

const setParams = (options) => {
  let _channel = '';
  if (window.sessionStorage.getItem('channelId')) {
    _channel = JSON.parse(window.sessionStorage.getItem('channelId'));
  }
  options = options || {};
  if (!options.channel) {
    options.channelId = _channel;
  }
  return JSON.stringify(options);
};

//解释Token
export const analyzeToken = (options) => {
  let _url = _interface.analyzeToken.replace('{0}', window.sessionStorage.getItem('channelId')).replace('{1}',options.token);
  let data = {
    url: _url,
    params:{
      jstoken:''
    },
    method: 'GET'
  };
  return data
}

//解释Token
export const getUserticket = (options) => {
  let data = {
    url: _interface.getUserticket,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}
//查询ABO信息
export const queryAboByAda = (options) => {
  let data = {
    url: _interface.queryAboByAda,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}
//查询ABO信息
export const sendSmsCode = (options) => {
  let data = {
    url: _interface.sendSmsCode,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}

//检验手机验证码
export const checkTelephoneCode = (options) => {
  let data = {
    url: _interface.checkSmsCode,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}

//检验手机号是否被使用
export const validateMobileNumberService = (options) => {
  let data = {
    url: _interface.validateMobileNumber,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}

// 验证身份证后6位接口
export const checkIdcardService = (options) => {
  let data = {
    url: _interface.checkIdcard,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}

//绑定手机接口
export const bindPhoneService = (options) => {
  let data = {
    url: _interface.bindPhone,
    body: setParams(options),    
    params:{
      jstoken:''
    },
    method: 'POST'
  };
  return data
}

//绑定手机接口
export const jsToken = () => {
  let data = {
    url: _interface.getJsToken + '?t=' + new Date().getTime(),
    method: 'GET'
  };
  return data
}
// dev 环境获取 jsToken
export const devJsToken = () => {
  let data = {
    url: _interface.devGetJsToken + '?t=' + new Date().getTime(),
    method: 'GET'
  };
  return data
}


//通过安全问题
export const findPwdBySafPro = (options) => {
  let data = {
    url: "/login/api/findPwdBySafPro",
    body: setBizParam(options),
    params: {
      jstoken: ''
    },
    method: "POST"
  };
  return data
}

//设置密码
export const setPassword = (options) => {
  let data = {
    url: "/login/api/setingNewPwd",
    body: setBizParam(options),
    params: {
      jstoken: ''
    },
    method: "POST"
  };
  return data
}
export const setPasswordEnd = (options) => {
  let data = {
    url: "/login/api/setingNewPwdEnd",
    body: setBizParam(options),
    params: {
      jstoken: ''
    },
    method: "POST"
  };
  return data
}
//未绑定手机号，要求输入证件号
export const findPwdByCardId = (options) => {
  let data = {
    url: "/login/api/findPwdByCardId",
    body: setBizParam(options),
    params: {
      jstoken: ''
    },
    method: "POST"
  };
  return data
}
//验证验证码
export const checkCode = (options) => {
  let data = {
    url: "/login/api/findPwdBySmsCode",
    body: setBizParam(options),
    params: {
      jstoken: ''
    },
    method: "POST"
  };
  return data
}

//忘记安利卡号
export const forgetAda = (options) => {
  let data = {
    url: _interface.forgetAda,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
}
//验证忘记密码信息
export const checkForgetPassword = (options) => {
  let data = {
    url: _interface.checkForgetPassword,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
}

export const setNewPwd = (options) => {
  let data = {
    url: _interface.setNewPwd,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const checkPwdToken = (options) => {
  let data = {
    url: _interface.checkPwdToken,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const adaAndPwd = (options) => {
  let data = {
    url: _interface.adaAndPwd,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const pnAndSms = (options) => {
  let data = {
    url: _interface.pnAndSms,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const pnAndPwd = (options) => {
  let data = {
    url: _interface.pnAndPwd,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const bindLine = (options) => {
  let data = {
    url: _interface.bindLine,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const getAndCheckUserId = (options) => { // line sso登录(授权信息)
  let data = {
    url: _interface.getAndCheckUserId,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};


export const queryAdaIsLineBinding = (options) => { // 检验是否绑定
  let data = {
    url: _interface.queryAdaIsLineBinding,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
};

export const getUserTicketOne=(options) => {  // sso生产用户凭证
  let data = {
    url: _interface.getUserTicketOne,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  };
  return data
}

export const findWhiteList = (options) => {
  let data = {
    url: _interface.findWhiteList,
    body: setParams(options),
    params: {
      jstoken: ''
    },
    method: 'POST'
  }
  return data 
}


// WEBPACK FOOTER //
// ./src/service/interface.js